<template>
    <div class="min-h-screen bg-gray-50">
      <div class="max-w-8xl mx-auto py-8 px-4">
        <!-- 筛选区域 -->
        <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
        <div class="flex justify-between items-center">
          <div class="flex items-center gap-4">
            <!-- 供应商下拉选择 -->
            <div class="relative"  v-if="isuse == 1">
              <button @click="toggleSupplierDropdown" class="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700 hover:bg-gray-50">
                <i class="fas fa-building"></i>
                <span class="whitespace-nowrap">{{ selectedSupplier.name || '选择供应商' }}</span>
                <i class="fas fa-chevron-down text-gray-400"></i>
              </button>
              <div v-if="showSupplierDropdown" class="absolute z-10 w-56 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg">
                <div class="py-2">
                  <div v-for="item in supply" :key="item.supply_id" @click="selectSupplier(item)" class="px-4 py-2 hover:bg-gray-50 cursor-pointer">
                     {{item.name}}
                  </div>
                </div>
              </div>
            </div>
            
            <!-- 日期范围选择 -->
            <!-- <div class="flex items-center gap-2">
              <input type="date" v-model="form.startDate" class="px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700">
              <span class="text-gray-500">至</span>
              <input type="date" v-model="form.endDate" class="px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700">
            </div> -->
          </div>

        
        <button  @click="search" class="px-6 py-2 bg-blue-600 text-white rounded-button hover:bg-blue-700 flex items-center gap-2">
             
                <span class="whitespace-nowrap">查询</span>
          </button>
          

        </div>
      </div>
        <!-- 数据概览 -->
        <div class="grid grid-cols-4 gap-6 mb-6">
          <div class="bg-white rounded-lg shadow-sm p-6" v-for="(item,index) in statistics" :key="index">
            <div class="flex items-center justify-between">
              <div>
                <p class="text-gray-500 text-sm">{{ item.title }}</p>
                <p class="text-2xl font-semibold mt-2">{{ item.value }}</p>
              </div>
  
            </div>
            <div class="mt-4 flex items-center text-sm">
              <span :class="item.trend.isUp?'text-green-500':'text-red-500'"
                ><i class="fas fa-arrow-up mr-1"></i>{{item.trend.percentage}}%</span
              >
              <span class="text-gray-500 ml-2">较昨日</span>
            </div>
          </div>

        </div>
        <!-- 进货趋势图表 -->
        <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
          <h3 class="text-lg font-medium mb-4">进货趋势</h3>
          <div ref="salesChart" style="height: 400px"></div>
        </div>
        <!-- 排行榜区域 -->
        <div class="grid grid-cols-3 gap-6">
          <!-- 商品进货排行 -->
          <div class="bg-white rounded-lg shadow-sm p-6">
            <h3 class="text-lg font-medium mb-4">商品进货排行 <button @click="exportToExcel(1)"  style="float: right;"
            class="text-blue-600 hover:text-blue-700 flex items-center !rounded-button whitespace-nowrap">
            <i class="fas fa-download mr-1"></i>
            导出
            </button>
            <div style="clear: both;"></div></h3>
           
            <div class="space-y-4">
              <div
                v-for="(item, index) in salesRanking"
                :key="index"
                class="flex items-center"
              >
                <div
                  class="w-6 h-6 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center text-sm font-medium"
                >
                  {{ index + 1 }}
                </div>
                <div class="ml-3 flex-1">
                  <div class="flex justify-between items-center">
                    <span class="text-gray-800">{{ item.name }}</span>
                    <span class="text-gray-600">¥ {{ item.sales }}</span>
                  </div>
                  <div class="w-full bg-gray-100 rounded-full h-1.5 mt-2">
                    <div
                      class="bg-blue-600 h-1.5 rounded-full"
                      :style="{ width: item.percentage + '%' }"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 商品浏览排行 -->
          <div class="bg-white rounded-lg shadow-sm p-6">
            <h3 class="text-lg font-medium mb-4">商品浏览排行  <button @click="exportToExcel(2)"  style="float: right;"
            class="text-blue-600 hover:text-blue-700 flex items-center !rounded-button whitespace-nowrap">
            <i class="fas fa-download mr-1"></i>
            导出
            </button>
            <div style="clear: both;"></div></h3>
          
            <div class="space-y-4">
              <div
                v-for="(item, index) in viewRanking"
                :key="index"
                class="flex items-center"
              >
                <div
                  class="w-6 h-6 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center text-sm font-medium"
                >
                  {{ index + 1 }}
                </div>
                <div class="ml-3 flex-1">
                  <div class="flex justify-between items-center">
                    <span class="text-gray-800">{{ item.name }}</span>
                    <span class="text-gray-600">{{ item.views }} 次</span>
                  </div>
                  <div class="w-full bg-gray-100 rounded-full h-1.5 mt-2">
                    <div
                      class="bg-purple-600 h-1.5 rounded-full"
                      :style="{ width: item.percentage + '%' }"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 退款排行 -->
          <div class="bg-white rounded-lg shadow-sm p-6">
            <h3 class="text-lg font-medium mb-4">退款排行   <button @click="exportToExcel(3)"  style="float: right;"
            class="text-blue-600 hover:text-blue-700 flex items-center !rounded-button whitespace-nowrap">
            <i class="fas fa-download mr-1"></i>
            导出
            </button>
            <div style="clear: both;"></div></h3>
         
            <div class="space-y-4">
              <div
                v-for="(item, index) in refundRanking"
                :key="index"
                class="flex items-center"
              >
                <div
                  class="w-6 h-6 rounded-full bg-red-100 text-red-600 flex items-center justify-center text-sm font-medium"
                >
                  {{ index + 1 }}
                </div>
                <div class="ml-3 flex-1">
                  <div class="flex justify-between items-center">
                    <span class="text-gray-800">{{ item.name }}</span>
                    <span class="text-gray-600">¥ {{ item.refund_amount }}</span>
                  </div>
                  <div class="w-full bg-gray-100 rounded-full h-1.5 mt-2">
                    <div
                      class="bg-red-600 h-1.5 rounded-full"
                      :style="{ width: item.percentage + '%' }"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import * as echarts from 'echarts';
  import Warehouse_managementApi from '@/api/warehouse_management.js';

import StatisticsApi from '@/api/statistics.js';
  export default {
    data() {
      return {
        selectedSupplier: {'name':""},
        showSupplierDropdown: false,
        startDate: '',
        endDate: '',
        supply:[],
        form:{
            startDate: '',
            endDate: '',
        },
        isuse:0,
        statistics:[],
        wholesalePoints: ['北京批发中心', '上海批发中心', '广州批发中心', '深圳批发中心'],
        storeMap: {
          '北京批发中心': ['朝阳区门店', '海淀区门店', '西城区门店', '东城区门店'],
          '上海批发中心': ['浦东新区门店', '静安区门店', '黄浦区门店', '徐汇区门店'],
          '广州批发中心': ['天河区门店', '越秀区门店', '荔湾区门店', '海珠区门店'],
          '深圳批发中心': ['南山区门店', '福田区门店', '罗湖区门店', '宝安区门店']
        },
        salesRanking: [
        ],
        viewRanking: [
        ],
        refundRanking: [
        
        ]
      };
    },

    created() {
          /*获取数据*/
      var self = this;
      self.getInas({},function(res){
        self.isuse = res
      })
      self.getSupplys()
      self.search();
 
    },
    computed: {
      filteredStores() {
        return this.selectedWholesale ? this.storeMap[this.selectedWholesale] : [];
      }
    },
    methods: {
        exportToExcel(type) {
            // 构建CSV数据
            var getCSVData = "";
            if(type == 1){
                 getCSVData = (data) => {
                const header = ['排名', '商品名称', '进货额'];
                const rows = data.map((item, index) => [index + 1, item.name, item.sales]);
                return [header, ...rows].map(row => row.join(',')).join('\n');
                };
            }else  if(type == 2){
                 getCSVData = (data) => {
                const header = ['排名', '商品名称', '浏览次数'];
                const rows = data.map((item, index) => [index + 1, item.name, item.views]);
                return [header, ...rows].map(row => row.join(',')).join('\n');
                };
            }else  if(type == 3){
                 getCSVData = (data) => {
                const header = ['排名', '商品名称', '退款额'];
                const rows = data.map((item, index) => [index + 1, item.name, item.refund_amount]);
                return [header, ...rows].map(row => row.join(',')).join('\n');
                };
            }
          

            // 创建并下载CSV文件
            const downloadCSV = (data, filename) => {
            const blob = new Blob(['\ufeff' + data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            link.click();
            URL.revokeObjectURL(link.href);
            };

            // 导出进货排行数据
          

            if(type == 1){
                const csvData = getCSVData(this.salesRanking);
                downloadCSV(csvData, '商品进货排行数据.csv');
            }else  if(type == 2){
                const csvData = getCSVData(this.viewRanking);
                downloadCSV(csvData, '商品浏览排行数据.csv');
            }else  if(type == 3){
                const csvData = getCSVData(this.refundRanking);
                downloadCSV(csvData, '商品退货排行数据.csv');
            }
          
      
            },
        getData(){
            let self = this;
            StatisticsApi.getOrderStatisticsCards(self.form, true)
            .then(res => {
                self.statistics  = res.data
            })
            .catch(error => {});
        },
        search(){
            this.getData();
            this.getProductSalesRanking();
            this.getProductViewRanking();
            this.getProductRefundRanking();
            
        },
        getProductSalesRanking(){
            let self = this;
            StatisticsApi.getProductSalesRanking(self.form, true)
            .then(res => {
                self.salesRanking = res.data;
            })
            .catch(error => {});
        },
        getProductViewRanking(){
            let self = this;
            StatisticsApi.getProductViewRanking(self.form, true)
            .then(res => {
                self.viewRanking = res.data;
            })
            .catch(error => {});
        },
        getProductRefundRanking(){
            let self = this;
            StatisticsApi.getProductRefundRanking(self.form, true)
            .then(res => {
                self.refundRanking = res.data;
            })
            .catch(error => {});
        },
        getSupplys(){
            let self = this;
    
    
            Warehouse_managementApi.getSupply({}, true)
                .then(data => {
              
                self.supply = data.data.supply
           
                })
                .catch(error => {
                });
        },
        toggleSupplierDropdown() {
        this.showSupplierDropdown = !this.showSupplierDropdown;
      },
      selectSupplier(supplier) {
        this.selectedSupplier = supplier;
        this.showSupplierDropdown = false;
        this.form.supply_id = supplier.supply_id
      },
      handleDateChange() {
        if (this.startDate && this.endDate) {
          this.refreshData();
        }
      },
      toggleWholesaleDropdown() {
        this.showWholesaleDropdown = !this.showWholesaleDropdown;
        this.showTimeDropdown = false;
        this.showStoreDropdown = false;
      },
      toggleStoreDropdown() {
        if (this.selectedWholesale) {
          this.showStoreDropdown = !this.showStoreDropdown;
          this.showWholesaleDropdown = false;
        }
      },
      selectWholesale(item) {
        this.selectedWholesale = item;
        this.selectedStore = '';
        this.showWholesaleDropdown = false;
      },
      selectStore(item) {
        this.selectedStore = item;
        this.showStoreDropdown = false;
      },
      refreshData() {
        // 刷新数据的逻辑
        if (this.startDate && this.endDate) {
          console.log('Date range:', this.startDate, 'to', this.endDate);
          // 这里添加根据日期范围获取数据的逻辑
        }
      },
      initSalesChart() {
        const chartDom = this.$refs.salesChart;
        const myChart = echarts.init(chartDom);
        let self = this;
            StatisticsApi.getSalesTrendChart(self.form, true)
            .then(res => {

                myChart.setOption(res.data);
                window.addEventListener('resize', () => {
                myChart.resize();
                });
            })
            .catch(error => {});
     
      }
    },
    mounted() {
      this.initSalesChart();
    },
    beforeDestroy() {
      window.removeEventListener('resize', () => {});
    }
  };
  </script>
  
  <style scoped>
  .custom-dropdown {
    max-height: 200px;
    overflow-y: auto;
  }
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type="date"] {
    font-family: inherit;
  }
  input[type="date"]::-webkit-calendar-picker-indicator {
    cursor: pointer;
    padding: 4px;
  }
  </style>


// WEBPACK FOOTER //
// src/views/statistics/sales/indexx.vue